import React from "react";

import QRLogInPblContainer from "../containers/QRLogInPblContainer";

const WebQRLogInPblPage = ({ ...props }) => {
    return (
        <QRLogInPblContainer {...props} />
    );
};

export default WebQRLogInPblPage;